/* eslint-disable react-hooks/exhaustive-deps */
import './ErrorBase.css';
import React, { useEffect } from 'react';
import { useStore } from '../../Context';
import { errorsKeys } from '../../constants/errorTypes';
import useTheme from '../../hooks/useTheme';
import loanlogs from '../../services/loanlogs';


function ErrorComponent({ errorKey }) {
    const { error } = useStore();
    
    const theme = useTheme();
    
    const errorMessage = errorsKeys[errorKey]?.message || error.description || 'Ha ocurrido un error';
    const buttonType = errorsKeys[errorKey]?.button || 'retry'
    const helpMessage = errorsKeys[errorKey]?.help_message || null;
    
    function retry() {
        window.location.reload();
    };
    function handleClose() {
        window.opener = null;
        window.open("", "_self");
        window.close();
    };

    useEffect(() => {
        loanlogs.success('/error', { response: { error, errorMessage }}).catch(console.log)
    }, []);
    
    if (error.type === "Already Signed" && error.type === "Link not found") {
        return (
            <main className='stack'>
                <h1 className='text-center text-3xl'>{errorMessage}</h1>
                <img src={`/${theme}/logo.png`} alt="" width="300" className="image-logo" />
            </main>
        );
    }

    return (
        <main className='page-step page-error-base stack'>
            <header className='page-header'>
                <h1 className='text-center text-3xl'>
                    {errorMessage}
                </h1>
            </header>
            <div className="page-content align-content">
                <div className="page-content self-center">
                    <img src={`/${theme}/logo.png`} alt="" width="300" className="image-logo"/>
                </div>
                {helpMessage && (<h3 className='text-center text-3xl'>
                    {helpMessage}
                </h3>)}
            </div>
            <div className="page-actions flex-column">
                {buttonType === 'close' ?
                    <button className="button-primary full-width" onClick={handleClose}>
                        Cerrar
                    </button>
                    :
                    <button className='button-primary full-width' onClick={retry}>
                        Reintentar
                    </button>
                }
            </div>
        </main>
    );
}

export default ErrorComponent;
